import { GUPPYCHAT_TRANSLATION } from "../resources/constants";
export default {
    data(){
        return {
            messagesOffset   	: 0,
            UserChatOffset 	    : 0,
            isLoading           : false,
            isScrolling         : false,
            RecordLimit         : Number(window.wpguppy_scripts_vars.showRec),
            StatusText          : window.wpguppy_scripts_vars.friendListStatusText,
            userId              : window.wpguppy_scripts_vars.userId,
            postId              : window.wpguppy_scripts_vars.postId,
            isSingle            : window.wpguppy_scripts_vars.isSingle,
            errors              : '',
            TRANS               : GUPPYCHAT_TRANSLATION,
        }
    },
    methods: {
        alertBox(type, title, description){ // type : warning, error, success, info, question
            this.$swal({
                icon: type,
                title: title,
                text: description,
                showCloseButton: true,
                showConfirmButton: false,
            })            
        }
    }
};